export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_German - Corporate - Horizontal - White.af85eb1a.svg";